<template>
    <div class="ranking-page">
        <!-- 背景图 -->
        <div class="ranking-page-bg"></div>
        <!-- top -->
        <div class="top" :style="{paddingTop: 10 + statusBarHeight + 'px'}">
            <div
                class="top-back"
            >
                <Back 
                    :clickHandle="handleClosePage"
                />
            </div>
        </div>
        <!-- switch -->
        <div class="switch">
            <div class="switch-item switch-item-left"
                @click="switchHandle('point')"
                :class="[{'active-left': currentShow == 'point'}]">
                <div class="switch-normalText"
                    :class="[{'active-text': currentShow == 'point'}]"
                >
                  {{ localesPackage?.['home_shop_daily']?.[localesEnv] }}
                </div>
            </div>
            <div class="switch-item"
                @click="switchHandle('medal')"
                :class="[{'active': currentShow == 'medal'}]">
                <div class="switch-normalText"
                    :class="[{'active-text': currentShow == 'medal'}]"
                >
                {{ localesPackage?.['home_shop_weekly']?.[localesEnv] }}
                </div>
            </div>
        </div>
        <!-- ranking tips -->
        <div class="ranking-tips" v-show="showDataGroup.length > 0">
            {{ 
                currentShow == "point" 
                ? localesPackage?.['home_shop_refresh_utc0_every_day']?.[localesEnv]
                : localesPackage?.['home_shop_refresh_utc0_every_week']?.[localesEnv]
            }}
        </div>
        <!-- ranking view -->
        <div class="ranking-view" ref="listView_ref" v-if="showDataGroup.length > 0">
            <div class="ranking-view-item" 
                :class="{
                    'no1': item.ranking == 1,
                    'no2': item.ranking == 2,
                    'no3': item.ranking == 3,
                }"
                 v-for="(item, index) in showDataGroup" 
                 :key="index">
                <div class="ranking-view-item-left">
                    <!-- 前三名特殊 -->
                    <img v-if="item?.ranking <= 3" 
                         :src="require(`@/assets/images/YuliApp/shopRank/no${item.ranking}.png`)"
                         class="ranking-view-item-left-rankingIcon">
                    <div v-else class="ranking-view-item-left-rankingNum">{{ item.ranking }}</div>
                    <img :src="item.avatar_url" class="ranking-view-item-left-userIcon" :onerror="imageLoadFailed">
                    <div class="ranking-view-item-left-userName">{{ item.username }}</div>
                </div>
                <div class="ranking-view-item-right">
                    <span class="ranking-view-item-right-num">{{ item.arg }}</span>
                    <span class="ranking-view-item-right-text">ARG</span>
                </div>
            </div>
        </div>
        <div class="ranking-nodata" v-else>
            <img :src="require('@/assets/images/YuliApp/shopRank/nodata_ranking.png')">
            <div class="ranking-nodata-text">
                {{ localesPackage?.['badgewall_no_rankingdata']?.[localesEnv] }}
            </div>
        </div>
        <!-- 分页 -->
        <div class="ranking-pageHandle" v-if="showDataGroup.length > 0">
            <div class="ranking-pageHandle-left contentBox"
                 :class="{'noAllow': curPage <= 1}"
                 @click="pageSwitchHandle('last')">
                 <div class="arrow"></div>
                {{ localesPackage?.['common_last_page']?.[localesEnv] }}
            </div>
            <div class="ranking-pageHandle-center">
                {{ `${curPage}/${maxPage}` }}
            </div>
            <div class="ranking-pageHandle-right contentBox"
                :class="{'noAllow': curPage >= maxPage}"
                @click="pageSwitchHandle('next')">
                {{ localesPackage?.['common_next_page']?.[localesEnv] }}
                <div class="arrow"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance, nextTick } from "vue";
import _ from "lodash";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import Back from "./Back";
import { getAppShopRankLanguage } from "@/api/language.js";
import { getShopRank } from "@/api/appGen.js";
import { NumberFormat } from "@/utils/utils.js";
import audioManager from "@/utils/audioManager";
import store from "@/store";

export default {
    components: {
        Back
    },
    props: {
        rankData: {
            type: Object,
            default: () => {
                return null
            }
        }
    },
    computed: {
        ...mapState({
            init: (state) => state.global.init,
            statusBarHeight: (state) => state.global.statusBarHeight,
            languageEnv: (state) => state.global.languageEnv,
            languagePackage: (state) => state.global.languagePackage,
        }),
    },
    watch: {
        rankData: {
            async handler(value) {
                console.log(value);
                if(value){
                    // console.log('rankData: ', value);
                    this.totalData = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languageEnv: {
            async handler(value) {
                if(value){
                this.localesEnv = value;
                }
            },
            immediate: true,
            deep: true,
        },
        languagePackage: {
            async handler(value) {
                if(value){
                this.localesPackage = value;
                }
            },
            immediate: true,
            deep: true,
        }
    },
    setup(props, { emit }) {
        const { proxy } = getCurrentInstance();
        /**语言包 - ref */
        const localesPackage = ref({});
        /**语言环境 - ref */
        const localesEnv = ref('en');
        const currentShow = ref('point');
        const totalData = ref(null);
        const listView_ref = ref(null);
        const allDataGroup = ref([]);
        const showDataGroup = ref([]);
        const self = ref(null);
        const selfClickTimes = ref(3);
        const maxPage = ref(0);
        const curPage = ref(0);
        const singlePageNum = 10;

        onBeforeMount(async ()=>{
            const res = await getAppShopRankLanguage();
            store.dispatch("global/setLanguagePackage", res);// 存到stroe
            appBridging.getStatusBarHeight();
            initHanlde();
        })

        /** 分页渲染处理*/
        const paginateHandle = (data, currentPage, pageSize) => {
            // 计算总页数
            const totalPage = Math.ceil(data.length / pageSize);

            // 确保当前页码在有效范围内
            currentPage = Math.min(Math.max(1, currentPage), totalPage);

            // 计算起始索引和结束索引
            const startIndex = (currentPage - 1) * pageSize;
            const endIndex = startIndex + pageSize;

            // 截取对应范围的数据
            const currentPageData = data.slice(startIndex, endIndex);

            return {
                currentPage,
                totalPage,
                pageSize,
                totalItems: data.length,
                data: currentPageData,
            }; 
        }

        const initHanlde = async (type) => {
            proxy.$loading.show();
            const res = await getShopRank({
                page: 1,
                page_size: 100,
                keyword: type
            });
            let useData = res?.data;
            // if(useData?.length >= 100){
            //     const res2 = await getShopRank({
            //         page: 2,
            //         page_size: 100,
            //         keyword: type
            //     });
            //     const useData2 = res2?.data;
            //     useData = [...useData, ...useData2];
            // }
            if(useData?.length > 0){
                useData = useData
                ?.sort((pre,next) => Number(next.arg) - Number(pre.arg))
                ?.map((item, index) => {
                    return {
                        ...item,
                        ranking: index+1,
                        arg: NumberFormat(item.arg),
                    }
                });
                const { currentPage, totalPage, totalItems, data } = paginateHandle(useData, 1, singlePageNum);
                curPage.value = currentPage;
                maxPage.value = totalPage;
                showDataGroup.value = data;
            }else {
                curPage.value = 0;
                maxPage.value = 0;
                showDataGroup.value = [];
            }
            allDataGroup.value = useData;
            proxy.$loading.hide();
        }

        /**头像加载失败事件 */
        const imageLoadFailed = (imgErrorEvent) => {
            const img = imgErrorEvent?.srcElement;
            if(img){
                img.src = require('@/assets/images/YuliApp/shopRank/default_avatar.png');
            }
        }

        const handleClosePage = () => {
            appBridging.closePage();
        }

        const switchHandle = (val, state) => {
            if(currentShow.value == val && state !== 'ignore')return;
            audioManager.playEffect("secondmenu");
            currentShow.value = val;
            initHanlde(val == 'medal' ? 'week' : '');
        }

        /** 分页切换处理*/
        const pageSwitchHandle = (mode = 'next') => {
            if(mode == 'last'){
                if(!(curPage.value <= 1))curPage.value--;
            }else{
                if(!(curPage.value >= maxPage.value))curPage.value++;
            }
            const { data } = paginateHandle(allDataGroup.value, curPage.value, singlePageNum);
            showDataGroup.value = data;
        }

        /** 捕获用户自我点击事件*/
        const selfClickHandle = () => {
            selfClickTimes.value = 3;
            selfClick();
        }

        /** 自我点击执行器*/
        const selfClick = () => {
            console.log('selfClick: ', selfClickTimes.value);
            const item = listView_ref.value?.querySelector('.ranking-view-item');
            let offsetNum;
            if(self.value.ranking < 10){
                offsetNum = 0;
            }else {
                offsetNum = (item.offsetHeight + 6) * (self.value.ranking - 1);
            }
            listView_ref.value.scrollTop = offsetNum;
            // 多次修改定点, 强制渲染画面 ios 滚动过渡bug
            nextTick(()=>{
                setTimeout(() => {
                    if(selfClickTimes.value > 0){
                        selfClick();
                        selfClickTimes.value --;
                    }
                }, 55);
            })
        }

        return {
            switchHandle,
            pageSwitchHandle,
            handleClosePage,
            selfClickHandle,
            currentShow,
            localesPackage,
            localesEnv,
            listView_ref,
            self,
            totalData,
            showDataGroup,
            maxPage,
            curPage,
            imageLoadFailed
        };
    },
};
</script>
  
<style lang="less" scoped>
@topHeight: 60px;
@screenTop: 10px;
.ranking-page{
    width: 100vw;
    height: 100vh;
    position: fixed;
    background: linear-gradient(180deg,
        #463D55 0%,
        #473F54 25%,
        #584A5C 50%,
        #745E6A 75%,
        #E1C893 100%
    );
    z-index: 999;
    top: 0;
    left: 0;
    &-bg{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: -1;
        background: url("~@/assets/images/YuliApp/shopRank/bg.png") no-repeat
        top left;
        background-size: 100% 100%;
    }
    .top{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: @topHeight;
        &-back{
            position: absolute;
            width: 64px;
            height: 32px;
            top: 50%;
            left: 0;
            transform: translate(0,-50%);
            img{
                width: 100%;
                height: 100%;
            }
        }
        &-right{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            &-iconView{
                width: 82px;
                height: 26px;
                position: relative;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: #ffffff;
                font-family: "PingFang SC";
                font-size: 12px;
                font-weight: 500;
                &-bg{
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    z-index: -1;
                }
                &-icon-share{
                    width: 24px;
                    height: 24px;
                    margin-right: 2px;
                }
            }
        }
        &-tag{
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0,-50%);
            font-size: 16px;
            width: fit-content;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 4px 10px;
            background-color: aquamarine;
            border-radius: 20px 0 0 20px;
        }
    }
    .switch{
        margin-top: calc(@topHeight + @screenTop + 10px);
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 100%;

        &-item{
            line-height: 34px;
            // width: 50%;
            // height: 100%;
            width: 155px;
            height: 31px;
            background: url("~@/assets/images/YuliApp/shopRank/normal_switch.png") no-repeat top left;
            background-size: 100% 100%;
            // margin: 0 10px;
            position: relative;
        }
        &-item-left{
            background: url("~@/assets/images/YuliApp/shopRank/normal_switch_left.png") no-repeat top left;
            background-size: 100% 100%;
        }
        &-normalText{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 1;
            color: #ecedee;
            font-size: 18px;
            font-weight: 500;
            font-family: "PingFang SC";
            text-align: center;
        }
        .active{
            background: url("~@/assets/images/YuliApp/shopRank/active_switch.png") no-repeat top left;
            background-size: 100% 100%;
        }
        .active-left{
            background: url("~@/assets/images/YuliApp/shopRank/active_switch_left.png") no-repeat top left;
            background-size: 100% 100%;
        }
        .active-text{
            color: #000;
        }
    }
    .ranking-tips{
        margin: 20px 0 8px 15px;
        color: #ffffff;
        text-align: left;
        font-family: "PingFang HK";
        font-size: 14px;
        font-weight: 600;
        line-height: 15px;
    }
    .ranking-view{
        display: flex;
        flex-direction: column;
        width: 345px;
        height: calc(100vh * 514/812);
        overflow-x: hidden;
        overflow-y: scroll;
        margin: 0 auto;
        position: relative;
        &-item{
            width: 100%;
            height: 46px;
            margin-bottom: 6px;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            background: rgba(255, 255, 255, 0.5);
            border: 1px solid rgba(0, 0, 0, 0.18);
            &-left{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                text-align: center;
                font-family: "PingFang SC";
                &-rankingIcon{
                    width: 32px;
                    height: 32px;
                    margin: 0 4px 0 8px;
                }
                &-rankingNum{
                    width: 37px;
                    text-align: center;
                    color: rgba(46, 46, 46, 0.8);
                    font-size: 18px;
                    font-weight: 600;
                    margin: 0 3px 0 4px;
                }
                &-userIcon{
                    width: 32px;
                    height: 32px;
                    border-radius: 32px;
                    border: 1px solid rgba(255, 255, 255, 0.7);
                    margin-right: 6px;
                }
                &-userName{
                    color: rgb(62, 57, 55);
                    font-size: 14px;
                    font-weight: 600;
                    text-align: left;
                    width: 160px;
                    height: 100%;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }
            &-right{
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: center;
                color: rgba(46, 46, 46, 0.8);
                font-family: "PingFang SC";
                font-size: 14px;
                font-weight: 600;
                &-num{
                    margin-right: 4px;
                }
                &-text{
                    margin-right: 14px;
                    white-space: nowrap;
                }
            }
        }
        .no1{
            background: url("~@/assets/images/YuliApp/shopRank/no1_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(168, 71, 0, 1);
            }
        }
        .no2{
            background: url("~@/assets/images/YuliApp/shopRank/no2_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(50, 105, 156, 1);
            }
        }
        .no3{
            background: url("~@/assets/images/YuliApp/shopRank/no3_bg.png") no-repeat
            top left;
            background-size: 100% 100%;
            border: unset;
            .ranking-view-item-right{
                color: rgba(139, 87, 65, 1);
            }
        }
        &-self{
            // position: fixed;
            // bottom: 0;
            // left: 0;
            background: rgba(255, 255, 255, 1);
            margin: 0 auto;
            width: 345px;
            .ranking-view-item-right{
                color: rgba(168, 71, 0, 1);
            }
        }
    }
    .ranking-nodata{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 70%;
        width: 100%;
        img{
            width: 120px;
            height: 120px;
            margin-bottom: 32px;
        }
        &-text{
            color: #76736f;
            font-size: 15px;
            font-weight: 600;
            font-family: "PingFang HK";
        }
    }

    .ranking-pageHandle{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin: 0 auto;
        margin-top: 24px;
        width: 80%;
        height: 50px;
        color: #4e4e4e;
        font-size: 14px;
        font-weight: 600;
        font-family: "PingFang SC";
        .contentBox{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
        }
        &-left{
            .arrow {
                margin-right: 4px;
                transform: rotate(180deg) rotateX(180deg);
            }
        }
        &-right{
            .arrow {
                margin-left: 4px;
            }
        }
        .arrow{
            width: 14px;
            height: 14px;
            background: url("~@/assets/images/YuliApp/shopRank/page_handle_arrow.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        &-center{
            width: 49px;
            height: 49px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            background: url("~@/assets/images/YuliApp/shopRank/page_handle_number.png") no-repeat
            top left;
            background-size: 100% 100%;
        }
        .noAllow{
            opacity: 0.5;
        }
    }
}
</style>